<template>
  <div class="lq-tool">
    <!-- IP -->
    <template v-if="activeTab === 'ip'">
      <div class="lq-hero">
        <div class="lq-hero-icon"><i class="el-icon-monitor" /></div>
        <div class="lq-hero-text"><h3>{{ $t('tool.LocationQuery.ipTitle') }}</h3></div>
      </div>
      <div class="lq-search">
        <el-input v-model="ipInput" :placeholder="$t('tool.LocationQuery.phIp')" size="medium" class="lq-input"
          @keyup.enter.native="queryIp" clearable />
        <el-button type="primary" size="medium" icon="el-icon-search" @click="queryIp">{{ $t('tool.LocationQuery.btnQuery') }}</el-button>
      </div>
      <div class="lq-cards" v-if="ipResult">
        <div class="lq-card" v-for="(v,k) in [{key: $t('tool.LocationQuery.country'), val: ipResult.country}, {key: $t('tool.LocationQuery.province'), val: ipResult.region}, {key: $t('tool.LocationQuery.city'), val: ipResult.city}, {key: $t('tool.LocationQuery.isp'), val: ipResult.isp}]" :key="k">
          <span class="lq-card-label">{{ v.key }}</span>
          <span class="lq-card-val">{{ v.val || '--' }}</span>
        </div>
      </div>
      <div class="lq-hint" v-if="ipInput && !ipResult">{{ $t('tool.LocationQuery.ipHint') }}</div>
    </template>

    <!-- ID Card -->
    <template v-if="activeTab === 'idcard'">
      <div class="lq-hero">
        <div class="lq-hero-icon" style="background:#f0f9eb"><i class="el-icon-postcard" style="color:#67c23a" /></div>
        <div class="lq-hero-text"><h3>{{ $t('tool.LocationQuery.idcardTitle') }}</h3></div>
      </div>
      <div class="lq-search">
        <el-input v-model="idInput" :placeholder="$t('tool.LocationQuery.phIdcard')" size="medium" class="lq-input"
          @input="onIdInput" maxlength="18" clearable />
      </div>
      <div class="lq-cards" v-if="idResult">
        <div class="lq-card"><span class="lq-card-label">{{ $t('tool.LocationQuery.district') }}</span><span class="lq-card-val lq-card-em">{{ idResult.province || '--' }} {{ idResult.city || '' }} {{ idResult.district || '' }}</span></div>
        <div class="lq-card"><span class="lq-card-label">{{ $t('tool.LocationQuery.birth') }}</span><span class="lq-card-val lq-card-em">{{ idResult.birth }}</span></div>
        <div class="lq-card"><span class="lq-card-label">{{ $t('tool.LocationQuery.gender') }}</span><span class="lq-card-val">{{ idResult.gender === '男' ? $t('tool.LocationQuery.male') : $t('tool.LocationQuery.female') }}</span></div>
        <div class="lq-card"><span class="lq-card-label">{{ $t('tool.LocationQuery.age') }}</span><span class="lq-card-val">{{ idResult.age }} {{ $t('common.unit.years') }}</span></div>
      </div>
      <div class="lq-hint" v-if="idInput && !idResult && idInput.length < 18">{{ $t('tool.LocationQuery.needMoreDigits', { n: 18 - idInput.length }) }}</div>
      <div class="lq-hint" v-if="idInput && idInput.length >= 18 && !idResult">{{ $t('tool.LocationQuery.invalidIdcard') }}</div>
    </template>

    <!-- Phone -->
    <template v-if="activeTab === 'phone'">
      <div class="lq-hero">
        <div class="lq-hero-icon" style="background:#fef0e6"><i class="el-icon-mobile-phone" style="color:#e6a23c" /></div>
        <div class="lq-hero-text"><h3>{{ $t('tool.LocationQuery.phoneTitle') }}</h3></div>
      </div>
      <div class="lq-search">
        <el-input v-model="phoneInput" :placeholder="$t('tool.LocationQuery.phPhone')" size="medium" class="lq-input"
          @input="onPhoneInput" maxlength="11" clearable />
      </div>
      <div class="lq-cards" v-if="phoneResult">
        <div class="lq-card"><span class="lq-card-label">{{ $t('tool.LocationQuery.carrier') }}</span><span class="lq-card-val lq-card-em">{{ phoneResult.carrier }}</span></div>
        <div class="lq-card"><span class="lq-card-label">{{ $t('tool.LocationQuery.province') }}</span><span class="lq-card-val">{{ phoneResult.province || '--' }}</span></div>
        <div class="lq-card"><span class="lq-card-label">{{ $t('tool.LocationQuery.city') }}</span><span class="lq-card-val">{{ phoneResult.city || '--' }}</span></div>
      </div>
      <div class="lq-hint" v-if="phoneInput && !phoneResult">{{ $t('tool.LocationQuery.phoneHint') }}</div>
    </template>
  </div>
</template>

<script>
// 手机号段 → 运营商（前3位）
const CARRIER_MAP = {
  '130':'联通','131':'联通','132':'联通','133':'电信',
  '134':'移动','135':'移动','136':'移动','137':'移动','138':'移动','139':'移动',
  '145':'联通','146':'联通','147':'移动','148':'移动','149':'移动',
  '150':'移动','151':'移动','152':'移动','153':'电信',
  '155':'联通','156':'联通','157':'移动','158':'移动','159':'移动',
  '162':'虚拟','165':'移动','166':'联通','167':'联通',
  '170':'虚拟','171':'虚拟','172':'虚拟','173':'电信','174':'联通',
  '175':'联通','176':'联通','177':'电信','178':'移动','179':'虚拟',
  '180':'电信','181':'电信','182':'移动','183':'移动','184':'移动',
  '185':'联通','186':'联通','187':'移动','188':'移动','189':'电信',
  '190':'电信','191':'电信','192':'广电','193':'电信','194':'联通',
  '195':'移动','196':'联通','197':'移动','198':'移动','199':'电信'
}
import phoneDB from './phone-data.js'
import { queryIp as apiQueryIp } from '../../api/site.js'
const PHONE_PREFIX = Object.assign({
  '1575514':'安徽|合肥','1340111':'北京','1350111':'北京','1360111':'北京','1370111':'北京','1380111':'北京','1390111':'北京',
  '1360161':'上海','1370161':'上海','1380161':'上海','1390161':'上海',
}, phoneDB)

const ID_PROV = {11:'北京市',12:'天津市',13:'河北省',14:'山西省',15:'内蒙古',21:'辽宁省',22:'吉林省',23:'黑龙江省',31:'上海市',32:'江苏省',33:'浙江省',34:'安徽省',35:'福建省',36:'江西省',37:'山东省',41:'河南省',42:'湖北省',43:'湖南省',44:'广东省',45:'广西',46:'海南省',50:'重庆市',51:'四川省',52:'贵州省',53:'云南省',54:'西藏',61:'陕西省',62:'甘肃省',63:'青海省',64:'宁夏',65:'新疆',71:'台湾省',81:'香港',82:'澳门'}
// 身份证区县数据（较大，按需查找）
var ID_CITY = window.ID_CITY || {}

export default {
  name:'LocationQueryTool', props:{ config:{ type:Object, default:()=>({}) } },
  data() {
    var dt = (this.config && this.config.defaultTab) || 'phone'
    var tabs = (this.config && this.config.tabs) || ['phone','idcard','ip']
    return {
      activeTab: tabs.indexOf(dt) >= 0 ? dt : tabs[0],
      phoneInput:'', phoneResult:null,
      idInput:'', idResult:null,
      ipInput:'', ipResult:null
    }
  },
  methods:{
    onPhoneInput() { var v=this.phoneInput.replace(/\D/g,'');this.phoneInput=v;this.phoneResult=null
      if(v.length>=3){var carrier=CARRIER_MAP[v.slice(0,3)]||'未知';var province='',city=''
        if(v.length>=7){var p7=v.slice(0,7);var loc=PHONE_PREFIX[p7];if(loc){var parts=loc.split('|');province=parts[0];city=parts[1]||''}}
        if(!province && v.length>=5){var p5=v.slice(0,5);var loc5=PHONE_PREFIX[p5];if(loc5){var parts5=loc5.split('|');province=parts5[0];city=parts5[1]||''}}
        if(!province) province=this.$t('tool.LocationQuery.notRecorded')
        this.phoneResult={carrier,province,city}
      }
    },
    onIdInput() { var v=this.idInput.replace(/[^\dXx]/g,'');this.idInput=v;this.idResult=null
      if(v.length!==18)return
      var prov=ID_PROV[v.slice(0,2)]||''
      var city='',district='',unknown=this.$t('tool.LocationQuery.unknown')
      var d=ID_CITY[v.slice(0,6)]||'';if(d){var parts=d.split('|');city=parts[0]||'';district=parts[1]||''}
      var birth=v.slice(6,14),y=parseInt(birth.slice(0,4)),m=parseInt(birth.slice(4,6)),d_=parseInt(birth.slice(6,8))
      if(isNaN(y)||isNaN(m)||isNaN(d_)||m<1||m>12||d_<1||d_>31)return
      var gender=parseInt(v[16])%2===1?'男':'女'
      var age=new Date().getFullYear()-y-(new Date()<new Date(new Date().getFullYear(),m-1,d_)?1:0)
      if(age<0||age>150)return
      this.idResult={province:prov||unknown,city,district,birth:birth.slice(0,4)+'-'+birth.slice(4,6)+'-'+birth.slice(6,8),gender,age}
    },
    async queryIp(){
      var v=this.ipInput.trim();this.ipResult=null
      if(!/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(v))return
      try {
        var res = await apiQueryIp(v)
        if (res.code === 200 && res.data) {
          this.ipResult = {
            country: res.data.country || '',
            region: res.data.region || '',
            city: res.data.city || '',
            isp: res.data.isp || ''
          }
          return
        }
      } catch(e) {}
      this.ipResult={country:this.$t('tool.LocationQuery.queryFailed'),region:this.$t('tool.LocationQuery.checkNetwork'),city:'',isp:''}
    },
    doAction(a){ if(a==='clear'){ this.phoneInput='';this.idInput='';this.ipInput='';this.phoneResult=null;this.idResult=null;this.ipResult=null } }
  }
}
</script>

<style scoped>
.lq-tool { display: flex; flex-direction: column; gap: 20px; }

/* Hero */
.lq-hero { display: flex; align-items: center; gap: 16px; }
.lq-hero-icon {
  width: 52px; height: 52px; border-radius: 14px; flex-shrink: 0;
  background: #f0f4ff; display: flex; align-items: center; justify-content: center;
  font-size: 24px; color: #4e7cff;
}
.lq-hero-text h3 { margin: 0; font-size: 16px; font-weight: 700; color: #1a1f36; }

/* Search */
.lq-search { display: flex; gap: 10px; }
.lq-input { flex: 1; min-width: 0; }

/* Result cards */
.lq-cards { display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 10px; }
.lq-card {
  background: #fafbfc; border: 1px solid #ebeef5; border-radius: 10px;
  padding: 16px 18px; display: flex; flex-direction: column; gap: 6px;
  transition: border-color .15s;
}
.lq-card:hover { border-color: #4e7cff; }
.lq-card-label { font-size: 11px; font-weight: 600; color: #909399; text-transform: uppercase; letter-spacing: 1px; }
.lq-card-val { font-size: 15px; color: #303133; font-weight: 500; word-break: break-all; }
.lq-card-em { font-size: 18px; font-weight: 700; color: #1a1f36; }

.lq-hint { font-size: 13px; color: #c0c4cc; text-align: center; padding: 8px 0; }

@media (max-width: 640px) {
  .lq-cards { grid-template-columns: 1fr 1fr; }
  .lq-hero-text h3 { font-size: 16px; }
}
</style>
